export enum LeaveType {
  Annual = 'Annual',
  Casual = 'Casual',
  Sick = 'Sick',
  Maternity = 'Maternity',
  Paternity = 'Paternity',
  Compensatory = 'Compensatory'
}

export enum LeaveCardColor {
  Annual = '#FCB562B0',
  Casual = '#9EF2B1B8',
  Sick = '#FFDA57B0',
  Maternity = '#F6C6EAB5',
  Paternity = '#B1AFFFB5',
  Compensatory = '#EACEB4BF'
}

export enum LeaveStatusType {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING'
}

export enum UserRole {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  OperationsLead = 'OperationsLead',
  ProjectManager = 'ProjectManager',
  Member = 'Member'
}

export enum RoleStatus {
  SuperAdmin = 'Super Admin',
  Admin = 'Admin',
  OperationsLead = 'Operations Lead',
  ProjectManager = 'Project Manager',
  Member = 'Member'
}

export enum ViewType {
  Desktop = 'Desktop',
  Mobile = 'Mobile'
}

export enum BreakPoints {
  XS = 0,
  SM = 600,
  MD = 900,
  LG = 1200,
  XL = 1536
}

export enum UserRoleAppFormat {
  SuperAdmin = 'SUPER_ADMIN',
  Admin = 'ADMIN',
  OperationsLead = 'OPERATIONS_LEAD',
  ProjectManager = 'PROJECT_MANAGER',
  Member = 'MEMBER'
}

export const adminUserRoles: UserRole[] = [
  UserRole.Admin,
  UserRole.SuperAdmin,
  UserRole.OperationsLead
];

export const leadRoles: UserRole[] = [UserRole.ProjectManager];

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

// Project Section
export enum ProjectCardColor {
  Yellow = '#FCE9A3CF',
  PinkRed = '#FCC3A3CF',
  MintGreen = '#CAFCA3CF',
  SeaBlue = '#A3FCE7CF',
  SkyBlue = '#A3E2FCCF',
  MistBlue = '#A3C7FCCF',
  Lavender = '#B5A3FCCF',
  CoralPink = '#EAA3FCCF',
  SalmonPink = '#FCADA3CF',
  RoseQuartz = '#FCA3B8CF'
}

export enum ProjectStatusColor {
  Initiating = '#FD0000',
  Executing = '#00BF7A',
  HypercareSupport = '#FD30B8',
  Completed = '#FBCD27CF',
  Discontinued = '#FC8800CF'
}

export enum ProjectStatusDisplayAs {
  Initiating = 'Initiating',
  Executing = 'Executing',
  HypercareSupport = 'Hypercare Support',
  Completed = 'Completed',
  Discontinued = 'Discontinued'
}

export enum ProjectStatus {
  INITIATED = 'INITIATED',
  ONGOING = 'ONGOING',
  HYPERCARE_SUPPORT = 'HYPERCARE_SUPPORT',
  COMPLETED = 'COMPLETED',
  DISCONTINUED = 'DISCONTINUED'
}

export enum ProjectTypes {
  FixedTimeFixedCostProject = 'Fixed-Time Fixed-Cost Project',
  TimeAndMaterialProject = 'Time & Material Project',
  TimeAndMaterialWithBudgetCap = 'Time & Material with Budget Cap'
}

export enum ApprovalRequestType {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export const projectCardColors: ProjectCardColor[] = [
  ProjectCardColor.Yellow,
  ProjectCardColor.PinkRed,
  ProjectCardColor.MintGreen,
  ProjectCardColor.SeaBlue,
  ProjectCardColor.SkyBlue,
  ProjectCardColor.MistBlue,
  ProjectCardColor.Lavender,
  ProjectCardColor.CoralPink,
  ProjectCardColor.SalmonPink,
  ProjectCardColor.RoseQuartz
];

export const ActiveStatus = [
  ProjectStatus.INITIATED,
  ProjectStatus.HYPERCARE_SUPPORT,
  ProjectStatus.ONGOING
];

export const ActiveProjectTypes = [
  ProjectTypes.FixedTimeFixedCostProject,
  ProjectTypes.TimeAndMaterialProject,
  ProjectTypes.TimeAndMaterialWithBudgetCap
];

export const CompletedStatus = [
  ProjectStatus.COMPLETED,
  ProjectStatus.DISCONTINUED
];

export const MapStatusToDisplayAs = (status: string): string => {
  const statusMap: { [key in ProjectStatus]: string } = {
    [ProjectStatus.INITIATED]: ProjectStatusDisplayAs.Initiating,
    [ProjectStatus.ONGOING]: ProjectStatusDisplayAs.Executing,
    [ProjectStatus.HYPERCARE_SUPPORT]: ProjectStatusDisplayAs.HypercareSupport,
    [ProjectStatus.COMPLETED]: ProjectStatusDisplayAs.Completed,
    [ProjectStatus.DISCONTINUED]: ProjectStatusDisplayAs.Discontinued
  };
  return statusMap[status as ProjectStatus];
};

export const MapTypeToDisplayInCard = (type: string): string => {
  const typesMap: { [key in ProjectTypes]: string } = {
    [ProjectTypes.FixedTimeFixedCostProject]: 'FTFC',
    [ProjectTypes.TimeAndMaterialProject]: 'T&M',
    [ProjectTypes.TimeAndMaterialWithBudgetCap]: 'T&M Cap'
  };
  return typesMap[type as ProjectTypes];
};

export const MapTypesToDisplayAs = (status: string): string => {
  const typesMap: { [key in ProjectTypes]: string } = {
    [ProjectTypes.FixedTimeFixedCostProject]:
      ProjectTypes.FixedTimeFixedCostProject,
    [ProjectTypes.TimeAndMaterialProject]: ProjectTypes.TimeAndMaterialProject,
    [ProjectTypes.TimeAndMaterialWithBudgetCap]:
      ProjectTypes.TimeAndMaterialWithBudgetCap
  };
  return typesMap[status as ProjectTypes];
};

export const MapStatusToColor = (status: string): string => {
  const statusMap: { [key in ProjectStatus]: string } = {
    [ProjectStatus.INITIATED]: ProjectStatusColor.Initiating,
    [ProjectStatus.ONGOING]: ProjectStatusColor.Executing,
    [ProjectStatus.HYPERCARE_SUPPORT]: ProjectStatusColor.HypercareSupport,
    [ProjectStatus.COMPLETED]: ProjectStatusColor.Completed,
    [ProjectStatus.DISCONTINUED]: ProjectStatusColor.Discontinued
  };
  return statusMap[status as ProjectStatus];
};
